import { render, staticRenderFns } from "./step4.vue?vue&type=template&id=48d9d40c&scoped=true&"
import script from "./step4.vue?vue&type=script&lang=js&"
export * from "./step4.vue?vue&type=script&lang=js&"
import style0 from "./step4.vue?vue&type=style&index=0&id=48d9d40c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d9d40c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d9d40c')) {
      api.createRecord('48d9d40c', component.options)
    } else {
      api.reload('48d9d40c', component.options)
    }
    module.hot.accept("./step4.vue?vue&type=template&id=48d9d40c&scoped=true&", function () {
      api.rerender('48d9d40c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/activeManage/detail/step4.vue"
export default component.exports